/**
 * Line every value up in one column, whatever the label lengths.
 *
 * A horizontal `DataList` lays each item out as its own flex row, so the value
 * starts wherever that row's label ends — one long label ("Authentication
 * Method") pushes its value out of line with the rest. Making the root a
 * two-column grid and collapsing the items with `display: contents` promotes
 * every `dt`/`dd` into that grid, so all labels share one column sized to the
 * widest. No hardcoded width, so it survives translation.
 *
 * Only applies from `2xl` up, where the lists are horizontal. Below that they
 * go vertical (label above value), which needs no shared column — and would in
 * fact be broken by one. Pair it with
 * `orientation={{ base: 'vertical', '2xl': 'horizontal' }}`.
 *
 * Not for value-only lists: with no `DataList.ItemLabel` to fill it, the label
 * column would just sit empty.
 */
export const ALIGNED_LABEL_COLUMNS = {
  display: { '2xl': 'grid' },
  gridTemplateColumns: { '2xl': 'auto 1fr' },
  alignItems: { '2xl': 'center' },
  columnGap: { '2xl': 6 },
  '& .chakra-data-list__item': { display: { '2xl': 'contents' } },
} as const
